export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RESTORE_SESSION = 'RESTORE_SESSION';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_AUTH_USER_PERMISSIONS = 'SET_AUTH_USER_PERMISSIONS';

export const POST_OTP_REQUEST = 'POST_OTP_REQUEST';
export const POST_OTP_SUCCESS = 'POST_OTP_SUCCESS';
export const POST_OTP_FAILURE = 'POST_OTP_FAILURE';

export const POST_LOGIN_WITH_OTP_REQUEST = 'POST_LOGIN_WITH_OTP_REQUEST';
export const POST_LOGIN_WITH_OTP_SUCCESS = 'POST_LOGIN_WITH_OTP_SUCCESS ';
export const POST_LOGIN_WITH_OTP_FAILURE = 'POST_LOGIN_WITH_OTP_FAILURE';

export const POST_CONTACT_OTP_REQUEST = 'POST_CONTACT_OTP_REQUEST';
export const POST_CONTACT_OTP_SUCCESS = 'POST_CONTACT_OTP_SUCCESS';
export const POST_CONTACT_OTP_FAILURE = 'POST_CONTACT_OTP_FAILURE';

export const DISCONNECT_CALENDAR_BY_ID_REQUEST = 'DISCONNECT_CALENDAR_BY_ID_REQUEST';
export const DISCONNECT_CALENDAR_BY_ID_SUCCESS = 'DISCONNECT_CALENDAR_BY_ID_SUCCESS';
export const DISCONNECT_CALENDAR_BY_ID_FAILURE = 'DISCONNECT_CALENDAR_BY_ID_FAILURE';

export const LOG_DEVICE_INFO = 'LOG_DEVICE_INFO';
export const LOG_DEVICE_INFO_BY_ID_SUCCESS = 'LOG_DEVICE_INFO_BY_ID_SUCCESS';
export const LOG_DEVICE_INFO_BY_ID_FAILURE = 'LOG_DEVICE_INFO_BY_ID_FAILURE';